module.exports = __webpack_public_path__ + "img/google-play.f6b9ef59.png";